// extracted by mini-css-extract-plugin
module.exports = {"container":"_3BxvKoklyzMW1gAZOy0jlW","digit":"_2uI-5k43viTOL8uRqXGRt3"};